const Accessible = function (Glide, Components, Events) {
  let keydownShift = false;
  let autoFocus = true;

  const FOCUSABLE_ELEMENT_SELECTOR =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const FOCUS_DIRECTIONS = {
    backwards: 'backwards',
    forwards: 'forwards',
  };
  Object.freeze(FOCUS_DIRECTIONS);

  function focusFirstFocusableElement(element) {
    const focusableElements = element.querySelectorAll(
      FOCUSABLE_ELEMENT_SELECTOR
    );
    focusableElements[0].focus({ preventScroll: true });
  }

  function focusLastFocusableElement(element) {
    const focusableElements = element.querySelectorAll(
      FOCUSABLE_ELEMENT_SELECTOR
    );
    focusableElements[focusableElements.length - 1].focus({
      preventScroll: true,
    });
  }

  function elementsAfterElementInContainer(containerElement, element) {
    const childrenElementList = Array.from(containerElement.children);
    const elementIndex = childrenElementList.indexOf(element);

    const elementsAfterElement = childrenElementList.filter(element => {
      const index = childrenElementList.indexOf(element);
      return index > elementIndex;
    });

    return elementsAfterElement;
  }

  function findFirstTabableElementInElementList(elementList) {
    const nextChildrenWithTabableElement = elementList.find(element => {
      return (
        !!element.querySelector(FOCUSABLE_ELEMENT_SELECTOR) ||
        !!element.matches(FOCUSABLE_ELEMENT_SELECTOR)
      );
    });

    const nextTabableElement =
      nextChildrenWithTabableElement.matches(FOCUSABLE_ELEMENT_SELECTOR) ||
      nextChildrenWithTabableElement.querySelector(FOCUSABLE_ELEMENT_SELECTOR);

    return nextTabableElement;
  }

  const Accessible = {
    mount() {
      Events.emit('Accessible.mount');
      window.addEventListener('keydown', this.enableAutoFocus);
      window.addEventListener('mousedown', this.disableAutoFocus);
      window.addEventListener('keydown', this.keyStrokeHandler);
      window.addEventListener('keyup', this.keyStrokeHandler);
    },

    get focusDirection() {
      return keydownShift
        ? FOCUS_DIRECTIONS.backwards
        : FOCUS_DIRECTIONS.forwards;
    },

    get activeSlideElementList() {
      return Components.Html.wrapper.querySelectorAll(
        `.glide__slide--visible`
        // `.${Glide.settings.classes.slide.active}`
      );
    },

    get slideElementList() {
      const slideElementList = [
        ...Components.Clones.items,
        ...Components.Html.slides,
      ];
      return slideElementList;
    },

    enableAutoFocus() {
      autoFocus = true;
    },

    disableAutoFocus() {
      autoFocus = false;
    },

    keyStrokeHandler(event) {
      if (event.key !== 'Shift') return;
      if (event.type === 'keydown') keydownShift = true;
      if (event.type === 'keyup') keydownShift = false;
    },

    onFocusin(event) {
      const focusInsideActiveSlide = !!event.target.closest(
        `.glide__slide--visible`
        // `.${Glide.settings.classes.slide.active}`
      );
      if (focusInsideActiveSlide) return;

      const relatedTarget = event.relatedTarget;
      const isEmitterInsideTrackElement =
        Components.Html.track.contains(relatedTarget);

      if (isEmitterInsideTrackElement) {
        Accessible.redirectFocusOut();
      } else {
        Accessible.redirectFocusToCurrentSlide();
      }

      // TODO: prüfen ob wir das an dieser Stelle auch brauchen
      // if (this.hasControls) {
      // this.correctFocus(isEmitterInsideTrackElement);
      // } else {
      //   // TODO: prüfen ob das nicht auch durch eine Bedingung bedingt sein sollte..
      //   this.flickitySelect(this.slideIndex, true, false);
      // }

      Components.Html.track.scrollLeft = 0;
    },

    redirectFocusToCurrentSlide() {
      // this.flickitySelect(this.context.flickity.selectedIndex, true, false);

      const activeSlideElementList = Accessible.activeSlideElementList;

      if (Accessible.focusDirection === FOCUS_DIRECTIONS.backwards) {
        const lastSlideIndex = activeSlideElementList.length - 1;
        const lastSlideElement = activeSlideElementList[lastSlideIndex];
        focusLastFocusableElement(lastSlideElement);
      } else {
        const firstSlideElement = activeSlideElementList[0];
        focusFirstFocusableElement(firstSlideElement);
      }
    },

    findFirstTabableElementAfterTrackElement() {
      const rootElement = Components.Html.root;
      const trackElement = Components.Html.track;

      const elementsAfterTrackElement = elementsAfterElementInContainer(
        rootElement,
        trackElement
      );

      const nextTabableElement = findFirstTabableElementInElementList(
        elementsAfterTrackElement
      );

      return nextTabableElement;
    },

    redirectFocusOut() {
      if (Accessible.focusDirection === FOCUS_DIRECTIONS.forwards) {
        const nextElement =
          Accessible.findFirstTabableElementAfterTrackElement();
        return nextElement && nextElement.focus();
      } else {
        const rootElement = Components.Html.root;

        // hier haben wir den selector des vorherigen elementes festgelegt
        // da dieser sich höchst wahrscheinlich nicht mehr ändern wird
        const previousTabableElement = rootElement.querySelector(
          '.glide-skiplink' // aus dpc-scroller.vue
        );
        return previousTabableElement && previousTabableElement.focus();
      }
    },

    focusFirstActiveSlide() {
      const activeSlideElementList = Accessible.activeSlideElementList;
      const firstActiveSlideElement = activeSlideElementList[0];
      firstActiveSlideElement && firstActiveSlideElement.focus();
    },

    updateAria() {
      const activeSlideElementList = Accessible.activeSlideElementList;
      const slideElementList = Accessible.slideElementList;

      slideElementList.forEach(slideElement => {
        slideElement.setAttribute('aria-hidden', true);
      });

      activeSlideElementList.forEach(slideElement => {
        slideElement.removeAttribute('aria-hidden');
      });
    },
  };

  Events.on('build.after', function () {
    Accessible.slideElementList.forEach(slideElement => {
      slideElement?.addEventListener('focusin', Accessible.onFocusin, true);
    });
    Accessible.updateAria();
  });

  Events.on('run.after', function () {
    autoFocus && Accessible.focusFirstActiveSlide();
    Accessible.updateAria();
  });

  // Events.on('update', function () {
  //   console.log('update');
  // });

  Events.on('destroy', () => {
    Accessible.slideElementList.forEach(slideElement => {
      slideElement?.removeEventListener('focusin', Accessible.onFocusin, true);
    });
  });

  return Accessible;
};

export { Accessible };
